import React from "react";
import { Link } from "react-router-dom";

/**
 * 將文字中的 /result?... 片段替換為 <Link>結果</Link>
 * - 僅匹配站內結果頁連結（/result?id=xxx 或 /result?img=...）
 * - 不顯示實際 URL，統一顯示「結果」
 */
export function renderWithResultLinks(s?: string): React.ReactNode {
  if (!s) return null;

  // 支援 /result?id=123 與 /result?img=BASE64... 等片段
  const re = /(\/result\?(?:id=\d+|img=[^\s\n]+))/g;
  const parts = s.split(re);

  return parts.map((part, i) => {
    if (re.test(part)) {
      return (
        <Link
          key={`link-${i}`}
          to={part}
          style={{ color: "#60a5fa", textDecoration: "none" }}
        >
          結果
        </Link>
      );
    }
    return <React.Fragment key={`txt-${i}`}>{part}</React.Fragment>;
  });
}

/**
 * 將任意值安全轉為可顯示字串
 */
export function toDisplayString(x: unknown): string {
  if (typeof x === "string") return x;
  try {
    return JSON.stringify(x);
  } catch {
    return String(x);
  }
}